import React from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
import baseStyles from '../../styles.module.css';

export type Props = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> & {
  hasError?: boolean;
};

export const WisorySelect = React.forwardRef<HTMLSelectElement, Props>(
  ({ className = '', hasError, children, ...otherProps }, ref) => {
    return (
      <select
        className={clsx(baseStyles.baseWrapper, styles.dropdownWrapper, styles.dropdown, className, 'font-openSans', {
          [baseStyles.error]: hasError,
          [baseStyles.emptyValue]: !otherProps.value,
        })}
        ref={ref}
        {...otherProps}
      >
        {children}
      </select>
    );
  }
);

WisorySelect.displayName = 'WisorySelect';
